import { Tile, Link } from 'carbon-components-react'
import AuthContext from '../context/AuthContext'
import React, { useContext } from 'react'

const Footer = () => {

  let { user } = useContext(AuthContext)

  return (
    <>
      {user &&
        <Tile id="footer">
          <div>
            <ul style={{ display: 'flex' }}>
              <li>
                Copyright &copy; {new Date().getFullYear()}
                <Link to="https://fenwig.co.uk"> Fenwig Technologies Ltd</Link>.
                All rights reserved.
              </li>
              <li style={{ marginLeft: 'auto' }}>
                <Link to="./changelog.html" rel="noopener">v0.0.3</Link>
              </li>
            </ul>
          </div>
        </Tile>
      }
    </>
  )
}

export default Footer